export default __webpack_public_path__ + "static/media/laser-hair-removal.42fbf4e2.pdf";